module.exports = __webpack_public_path__ + "img/star-filled.2a41a3b5.svg";